<div class="modal-body">
	<ng-content></ng-content>
</div>
